import { render, staticRenderFns } from "./UniImage.vue?vue&type=template&id=bf73650c&scoped=true"
import script from "./UniImage.vue?vue&type=script&setup=true&lang=js"
export * from "./UniImage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UniImage.vue?vue&type=style&index=0&id=bf73650c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf73650c",
  null
  
)

export default component.exports